import { Spinner } from 'react-bootstrap'
import { CustomRadioButton } from './CustomRadioButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger } from 'react-bootstrap'
import { LeftPositionedToolTip } from 'modules/DealerVehicleManagement/VehicleDetails.styled'
import { StyledDeliveryCard } from 'modules/StyledModel'

interface IProps {
  imageSrc: string
  altText: string
  quotePrice: number | null
  radioName: string
  radioValue: string
  radioId?: string
  isLoading?: boolean
  errorMessage?: string | null
  disabled?: boolean
  checked?: boolean
  toolTipText?: string
  onChange: () => void
}

export const DeliveryChargeCard = ({
  imageSrc,
  radioId,
  altText,
  quotePrice,
  radioName,
  radioValue,
  isLoading,
  errorMessage,
  disabled,
  checked = false,
  toolTipText,
  onChange
}: IProps) => {
  return (
    <StyledDeliveryCard>
      <img src={imageSrc} alt={altText} />

      <div className="price-info">
        Total Delivery Charge:{' '}
        {isLoading ? (
          <Spinner style={{ color: '#173B68' }} animation="border" />
        ) : (
          quotePrice !== null && <span style={{ marginLeft: '5px' }}>${quotePrice.toFixed(2)}</span>
        )}
        <OverlayTrigger
          placement="top"
          overlay={
            <LeftPositionedToolTip id="tooltip" style={{ marginLeft: '10px' }}>
              <span>{toolTipText}</span>
            </LeftPositionedToolTip>
          }
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginLeft: '5px', fontSize: '14px', color: '#173B68', cursor: 'pointer' }}
          />
        </OverlayTrigger>
        {errorMessage && <h6 style={{ color: 'red' }}>{errorMessage}</h6>}
      </div>

      <div className="radio-container">
        <CustomRadioButton
          name={radioName}
          checked={checked}
          onChange={onChange}
          id={radioId}
          value={radioValue}
          disabled={disabled || isLoading}
        />
      </div>
    </StyledDeliveryCard>
  )
}
